module.exports = __webpack_public_path__ + "img/heart-half-stroke.59a26399.svg";